import React, { lazy, Suspense } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Props, ComponentState } from './types';

const Components: { [key: string]: ComponentState } = {};

const Lazy: React.FC<Props> = (props): React.ReactElement | null => {
  const { componentImport, componentChunkName, componentProps } = props;

  // 1. 同步檢查與賦值 (防止閃爍)
  if (!Components[componentChunkName]) {
    Components[componentChunkName] = lazy(async () => componentImport);
  }

  const Component = Components[componentChunkName];
  if (!Component) return null;

  return (
    <Suspense fallback={<Skeleton variant="rectangular" width="100%" height="100%" animation="wave" />}>
      <Component {...componentProps} />
    </Suspense>
  );
};

export default Lazy;
